(function () {
  'use strict';

  const roots = document.querySelectorAll('[data-philu-reviews]');
  if (!roots.length) return;

  const engine = window.PhilUReviews;
  if (!engine) return;
  const {
    normalizeMediaUrl,
    dateValue,
    formatDate,
    formatReviewerName,
    badgeLabel,
    starString
  } = engine;

  const createText = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    node.textContent = text == null ? '' : String(text);
    return node;
  };

  const avatarText = (name) => {
    const parts = formatReviewerName(name).replace(/\./g, '').split(/\s+/).filter(Boolean).slice(0, 2);
    return parts.map((p) => p.charAt(0).toUpperCase()).join('') || 'C';
  };

  roots.forEach((root) => {
    if (root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    const csvUrl = String(root.dataset.csvUrl || '').trim();
    const productKey = String(root.dataset.productKey || '').trim();
    const pageSize = Math.max(1, Math.min(24, Number(root.dataset.pageSize) || 8));
    const showLocation = root.dataset.showLocation !== 'false';

    const refs = {
      summary: root.querySelector('[data-review-summary]'),
      score: root.querySelector('[data-review-score]'),
      scoreStars: root.querySelector('[data-review-score-stars]'),
      count: root.querySelector('[data-review-count]'),
      recommend: root.querySelector('[data-review-recommend]'),
      distribution: root.querySelector('[data-review-distribution]'),
      toolbar: root.querySelector('[data-review-toolbar]'),
      filterButtons: [...root.querySelectorAll('[data-review-filter]')],
      sort: root.querySelector('[data-review-sort]'),
      list: root.querySelector('[data-review-list]'),
      status: root.querySelector('[data-review-status]'),
      loadMore: root.querySelector('[data-review-load-more]')
    };

    if (!csvUrl || !productKey || !refs.list) return;

    const state = { rows: [], rating: null, photosOnly: false, sort: 'featured', visibleLimit: pageSize };

    const setStatus = (message, hidden = false) => {
      if (!refs.status) return;
      refs.status.textContent = message || '';
      refs.status.hidden = hidden;
    };

    const productReviews = () => engine.rowsFor(state.rows, productKey);
    const hasRating = (review) => review && review.rating !== null && review.countsTowardRating;
    const summary = () => engine.summaryFor(state.rows, productKey);

    const renderSummary = () => {
      const s = summary();
      const total = s.reviews.length;
      const ratedCount = s.rated.length;

      if (!total) {
        if (refs.summary) refs.summary.hidden = true;
        if (refs.toolbar) refs.toolbar.hidden = true;
        return;
      }

      if (refs.summary) refs.summary.hidden = false;
      if (refs.toolbar) refs.toolbar.hidden = false;
      if (refs.count) refs.count.textContent = `${total} ${total === 1 ? 'review' : 'reviews'}`;
      if (refs.score) refs.score.textContent = ratedCount ? s.average.toFixed(1) : '—';

      if (refs.scoreStars) {
        refs.scoreStars.textContent = ratedCount ? starString(s.average) : '';
        refs.scoreStars.setAttribute('aria-label', ratedCount ? `${s.average.toFixed(1)} out of 5 stars` : 'No star rating');
      }

      const positive = s.positive;
      if (refs.recommend) {
        refs.recommend.textContent = ratedCount ? `${positive}% rated this product 4 or 5 stars` : '';
        refs.recommend.hidden = !ratedCount;
      }

      if (refs.distribution) {
        refs.distribution.textContent = '';
        for (let rating = 5; rating >= 1; rating -= 1) {
          const amount = s.distribution[rating] || 0;
          const percent = ratedCount ? amount / ratedCount * 100 : 0;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'philu-product-reviews__distribution-row';
          button.dataset.rating = String(rating);
          button.disabled = !amount;
          button.setAttribute('aria-pressed', state.rating === rating && !state.photosOnly ? 'true' : 'false');
          if (state.rating === rating && !state.photosOnly) button.classList.add('is-active');

          button.appendChild(createText('span', null, `${rating} ★`));
          const track = createText('span', 'philu-product-reviews__distribution-track', '');
          const fill = createText('span', 'philu-product-reviews__distribution-fill', '');
          fill.style.width = `${Math.max(0, Math.min(100, percent))}%`;
          track.appendChild(fill);
          button.appendChild(track);
          button.appendChild(createText('span', null, amount));

          button.addEventListener('click', () => {
            if (!amount) return;
            state.rating = state.rating === rating && !state.photosOnly ? null : rating;
            state.photosOnly = false;
            state.visibleLimit = pageSize;
            renderAll();
          });
          refs.distribution.appendChild(button);
        }
      }

      refs.filterButtons.forEach((button) => {
        const f = button.dataset.reviewFilter;
        if (f === '5' || f === '4') button.disabled = !s.distribution[Number(f)];
        else if (f === 'photos') button.disabled = !s.reviews.some((r) => r.images.length);
        else button.disabled = false;
      });
    };

    const setActiveFilters = () => {
      refs.filterButtons.forEach((button) => {
        const f = button.dataset.reviewFilter;
        const active =
          (f === 'all' && !state.rating && !state.photosOnly) ||
          (f === String(state.rating) && !!state.rating && !state.photosOnly) ||
          (f === 'photos' && state.photosOnly);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    const renderMedia = (review) => {
      const urls = review.images.map(normalizeMediaUrl).filter(Boolean).slice(0, 6);
      if (!urls.length) return null;
      const gallery = createText('div', 'philu-product-review-card__media', '');
      urls.forEach((src) => {
        const img = document.createElement('img');
        img.src = src;
        img.alt = review.title ? `Customer photo for ${review.title}` : 'Customer review photo';
        img.loading = 'lazy';
        img.decoding = 'async';
        gallery.appendChild(img);
      });
      return gallery;
    };

    const renderCard = (review) => {
      const article = createText('article', 'philu-product-review-card', '');
      const top = createText('div', 'philu-product-review-card__top', '');

      if (hasRating(review)) {
        const stars = createText('span', 'philu-product-review-card__stars', starString(review.rating));
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', `${review.rating.toFixed(1)} out of 5 stars`);
        top.appendChild(stars);
      } else top.appendChild(document.createElement('span'));

      const time = createText('time', 'philu-product-review-card__date', formatDate(review.date));
      time.dateTime = review.date;
      top.appendChild(time);
      article.appendChild(top);

      if (review.title) article.appendChild(createText('h3', 'philu-product-review-card__title', review.title));
      if (review.body) article.appendChild(createText('p', 'philu-product-review-card__body', review.body));

      const media = renderMedia(review);
      if (media) article.appendChild(media);

      const reviewer = createText('div', 'philu-product-review-card__reviewer', '');
      const avatar = createText('span', 'philu-product-review-card__avatar', avatarText(review.name));
      avatar.setAttribute('aria-hidden', 'true');
      reviewer.appendChild(avatar);

      const identity = createText('div', 'philu-product-review-card__identity', '');
      const nameRow = createText('div', 'philu-product-review-card__name-row', '');
      nameRow.appendChild(createText('strong', 'philu-product-review-card__name', formatReviewerName(review.name)));

      const label = badgeLabel(review.badge);
      if (label) {
        const badge = createText(
          'span',
          /^Verified Buyer$/i.test(label) ? 'philu-product-review-card__verified' : 'philu-product-reviews__trust-note',
          label
        );
        if (/^Verified Buyer$/i.test(label)) badge.setAttribute('aria-label', 'Verified Buyer');
        nameRow.appendChild(badge);
      }

      identity.appendChild(nameRow);
      if (showLocation && review.location) {
        identity.appendChild(createText('small', 'philu-product-review-card__location', review.location));
      }

      reviewer.appendChild(identity);
      article.appendChild(reviewer);
      return article;
    };

    const filteredSorted = () => {
      let reviews = productReviews();
      if (state.rating) reviews = reviews.filter((r) => Math.round(r.rating || 0) === state.rating);
      if (state.photosOnly) reviews = reviews.filter((r) => r.images.length > 0);
      return [...reviews].sort((a, b) => state.sort === 'oldest' ? dateValue(a.date) - dateValue(b.date) : dateValue(b.date) - dateValue(a.date));
    };

    const renderAll = () => {
      renderSummary();
      setActiveFilters();
      const reviews = filteredSorted();
      refs.list.textContent = '';

      if (!reviews.length) {
        setStatus(productReviews().length ? 'No reviews match this filter.' : 'No customer reviews yet.');
        if (refs.loadMore) refs.loadMore.hidden = true;
        return;
      }

      reviews.slice(0, state.visibleLimit).forEach((r) => refs.list.appendChild(renderCard(r)));
      setStatus('', true);
      if (refs.loadMore) refs.loadMore.hidden = state.visibleLimit >= reviews.length;
    };

    refs.filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (button.disabled) return;
        const f = button.dataset.reviewFilter;
        state.rating = f === '5' || f === '4' ? Number(f) : null;
        state.photosOnly = f === 'photos';
        state.visibleLimit = pageSize;
        renderAll();
      });
    });

    if (refs.sort) refs.sort.addEventListener('change', () => {
      state.sort = ['featured', 'newest', 'oldest'].includes(refs.sort.value) ? refs.sort.value : 'featured';
      state.visibleLimit = pageSize;
      renderAll();
    });

    if (refs.loadMore) refs.loadMore.addEventListener('click', () => {
      state.visibleLimit += pageSize;
      renderAll();
    });

    const load = async () => {
      setStatus(refs.list.children.length ? 'Loading current reviews…' : 'Loading customer reviews…');
      try {
        state.rows = await engine.load(csvUrl);
        renderAll();
      } catch (error) {
        console.error('[PhilU reviews CSV]', error);
        if (!refs.list.children.length) setStatus('Reviews are temporarily unavailable.');
        else setStatus('', true);
      }
    };

    load();
  });
})();
